import {Optional} from "../../js/util/Optional";
import {Moment} from "moment";
import moment = require("moment");

export class SimulationDates {

    public readonly from: string;
    public readonly to: string;

    private constructor(private readonly _dates: Array<string>) {
        this.from = _dates[0];
        this.to = _dates[_dates.length - 1];
    }

    public get dates(): Array<string> {
        return [...this._dates];
    }

    public includes(input: string | Moment): boolean {
        let date: string;
        if (typeof input === "string") {
            date = input;
        } else {
            date = this.format(input);
        }
        return this._dates.includes(date);
    }

    public isInRange(input: string | Moment): boolean {
        let date: string;
        if (typeof input === "string") {
            date = input;
        } else {
            date = this.format(input);
        }
        const validByFrom = this.from.localeCompare(date) <= 0;
        const validByTo = this.to.localeCompare(date) >= 0;
        return validByFrom && validByTo;
    }

    private format(input: Moment): string {
        return input.format("YYYY-MM-DD");
    }

    public next(date: string): Optional<string> {
        if (!this.includes(date)) {
            return Optional.empty();
        }

        const current = moment(date);
        let next = current.add(1, "days");

        while (!this.includes(next)) {
            if (!this.isInRange(next)) {
                return Optional.empty();
            }

            next = next.add(1, "days");
        }
        const result = this.format(next);
        return Optional.of(result);
    }

    public previous(date: string): Optional<string> {
        if (!this.includes(date)) {
            return Optional.empty();
        }

        const current = moment(date);
        let next = current.add(-1, "days");

        while (!this.includes(next)) {
            if (!this.isInRange(next)) {
                return Optional.empty();
            }
            next = next.add(-1, "days");
        }
        const result = this.format(next);
        return Optional.of(result);
    }

    public static create(dates: Array<string>): SimulationDates {
        return new SimulationDates(dates);
    }
}
